(function(){
  var root=document.querySelector('.br-page');
  if(!root) return;

  /* filter dropdown toggles */
  root.querySelectorAll('[data-fttoggle]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.stopPropagation();
      var ft=btn.closest('[data-ft]');
      var wasOpen=ft.classList.contains('open');
      root.querySelectorAll('[data-ft].open').forEach(function(o){o.classList.remove('open');});
      if(!wasOpen) ft.classList.add('open');
    });
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest('[data-ft]')) root.querySelectorAll('[data-ft].open').forEach(function(o){o.classList.remove('open');});
  });

  /* sort — apply a sort value (preserves preview/view params) */
  function applySort(v){
    var u=new URL(window.location.href); u.searchParams.set('sort_by',v); u.searchParams.delete('page'); window.location.href=u.toString();
  }
  /* desktop: inline <select> */
  var ss=root.querySelector('[data-sortselect]');
  if(ss) ss.addEventListener('change',function(){ applySort(ss.value); });

  /* mobile: sort bottom-sheet opened by the icon button */
  var sheet=root.querySelector('[data-sortsheetel]');
  var sortBtn=root.querySelector('[data-sortsheet]');
  function openSheet(){ if(!sheet) return; sheet.classList.add('open'); sheet.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }
  function closeSheet(){ if(!sheet) return; sheet.classList.remove('open'); sheet.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; }
  if(sortBtn) sortBtn.addEventListener('click',function(e){ e.stopPropagation(); openSheet(); });
  if(sheet){
    sheet.querySelectorAll('[data-sortclose]').forEach(function(c){ c.addEventListener('click',closeSheet); });
    sheet.querySelectorAll('[data-sortval]').forEach(function(b){
      b.addEventListener('click',function(){ applySort(b.getAttribute('data-sortval')); });
    });
  }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeSheet(); });

  /* mobile product-image carousel: dots in sync with swipe (re-queries dots so it survives metal-swap rebuilds) */
  function syncDots(media){
    var track=media.querySelector('.br-track'); if(!track) return;
    var dots=media.querySelectorAll('.br-dot'); if(dots.length<2) return;
    var i=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));
    dots.forEach(function(d,di){ d.classList.toggle('active',di===i); });
  }
  function bindDots(media){
    media.querySelectorAll('.br-dot').forEach(function(d,di){
      if(d._b) return; d._b=1;
      d.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); var t=media.querySelector('.br-track'); if(t) t.scrollTo({left:di*t.clientWidth,behavior:'smooth'}); });
    });
  }
  root.querySelectorAll('.br-media').forEach(function(media){
    var track=media.querySelector('.br-track'); if(!track) return;
    var raf=null;
    track.addEventListener('scroll',function(){ if(raf) return; raf=requestAnimationFrame(function(){ raf=null; syncDots(media); }); },{passive:true});
    bindDots(media);
  });

  /* metal swatch -> swap the card image carousel + price + product link in place (no navigation) */
  root.querySelectorAll('.br-swatches .br-sw').forEach(function(a){
    a.addEventListener('click',function(e){
      e.preventDefault();
      if(a.classList.contains('sel')) return;
      var card=a.closest('.br-card'); if(!card) return;
      var media=card.querySelector('.br-media');
      var track=media&&media.querySelector('.br-track');
      var titleEl=card.querySelector('.br-ctitle');
      var priceEl=card.querySelector('.br-price .amt');
      var url=a.dataset.url||'#';
      var title=a.dataset.title||(titleEl?titleEl.textContent.trim():'');
      var imgs=(a.dataset.imgs||'').split('|').filter(Boolean);

      if(track&&imgs.length){
        track.innerHTML=imgs.map(function(u){
          return '<a class="br-slide" href="'+url+'" aria-label="'+title+'"><img src="'+u+'" alt="'+title+'" width="600" height="600"></a>';
        }).join('');
        track.scrollLeft=0;
        var dots=media.querySelector('.br-dots');
        if(imgs.length>1){
          if(!dots){ dots=document.createElement('div'); dots.className='br-dots'; media.appendChild(dots); }
          dots.innerHTML=imgs.map(function(_,i){ return '<span class="br-dot'+(i===0?' active':'')+'"></span>'; }).join('');
          bindDots(media);
        } else if(dots){ dots.remove(); }
      }
      if(priceEl&&a.dataset.price) priceEl.textContent=a.dataset.price;
      if(titleEl){ titleEl.setAttribute('href',url); if(a.dataset.title) titleEl.textContent=a.dataset.title; }
      var grp=a.parentNode;
      grp.querySelectorAll('.br-sw').forEach(function(x){ x.classList.remove('sel'); });
      a.classList.add('sel');
    });
  });
})();
